import React from 'react'
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { NavLink } from 'react-router-dom';
  
  function createData(name: string, date: string, sum: string, term: string) {
    return { name, date, sum, term };
  }
  
  const clients = [
    createData('Азаматов Азамаат Азаматович', '20.03.202 - 12:05', '15 000', '3 месяца'),
    createData('Азаматов Азамаат Азаматович', '20.03.202 - 12:05', '15 000', '3 месяца'),
    createData('Азаматов Азамаат Азаматович', '20.03.202 - 12:05', '15 000', '3 месяца'),
    createData('Азаматов Азамаат Азаматович', '20.03.202 - 12:05', '15 000', '3 месяца')
  ];

const RequestTable = () => {

    return (
        <TableContainer component={Paper}>
            <Table aria-label="simple table">
                <TableHead>
                <TableRow>
                    <TableCell align="left">№</TableCell>
                    <TableCell>Клиент</TableCell>
                    <TableCell align="left">Дата заявки</TableCell>
                    <TableCell align="left">Сумма</TableCell>
                    <TableCell align="left">Срок</TableCell>
                    <TableCell align="center"></TableCell>
                </TableRow>
                </TableHead>
                <TableBody>
                {clients.map((client, index) => (
                    <TableRow key={index}>
                        <TableCell align="left">{index + 1}</TableCell>
                        <TableCell component="th" scope="row">{client.name}</TableCell>
                        <TableCell align="center">{client.date}</TableCell>
                        <TableCell align="center">{client.sum}</TableCell>
                        <TableCell align="center">{client.term}</TableCell>
                        <TableCell align="center">
                            <NavLink to="/information">Просмотреть</NavLink>
                        </TableCell>
                    </TableRow>
                ))}
                </TableBody>
            </Table>
        </TableContainer>
    )
}

export default RequestTable